module.exports = __webpack_public_path__ + "static/media/  (101).42625ab4.jpg";